<template>
	<div class="firstbusiness">
		<div class="TopTitle">
			营业执照
			<div class="btnbtninformation" v-if="BLPBtnFlag == 0">
				<Btn btnType="btn" backgroundColor="#E71D43" width="92px" height="32px" title="提交审核" color="#FFFFFF"
					@btnclick="SubmitFreview"></Btn>
			</div>
			<div class="btnbtninformation" v-else-if="BLPBtnFlag == 1">
				<Btn btnType="btn" backgroundColor="#E71D43" width="92px" height="32px" title="修改" color="#FFFFFF" :useAutoOptional="false"
					@btnclick="SubmitHT"></Btn>
			</div>
			<div class="TopTitleRight" v-if="condition == 0">
				<div class="spot"></div>未审核
			</div>
			<div class="TopTitleRight" style="color: #424E66;" v-if="condition == 1">
				<div class="spot" style="background-color: #A1A9B3;"></div>审核中
			</div>
			<div class="TopTitleRight" style="color: #424E66;" v-if="condition == 2">
				<div class="spotimg"></div>审核通过
			</div>
			<div class="TopTitleRight" style="color: #E71D43;" v-if="condition == 3">
				<div class="spotimgerror"></div>已反驳
			</div>
		</div>
		<div class="TopLine"></div>
		<div class="res" v-if="RejectReason != null">
			<div class="reason">驳回原因</div>
			<div class="reasonText">
				{{ RejectReason }}
			</div>
		</div>
		<div class="TopLine"></div>

		<div class="technological ">
			<div class="TXsuccess" v-if="information == 1">
				<img src="../../../../../../assets/channel/firstbusiness/TXsuccess.png" alt="">
				填写信息
			</div>
			<div class="TXsuccess" v-else-if="information == 2">
				<img src="../../../../../../assets/channel/firstbusiness/successOK.png" alt="">
				填写成功
			</div>
			<div :class="[ information == 2 ? 'line1OK' : 'line1'  ]"></div>
			<div class="TXsuccess" style="color:#9CA5B8;" v-if="examine == 0">
				<img src="../../../../../../assets/channel/firstbusiness/info.png" alt="">
				审核中
			</div>
			<div class="TXsuccess" v-else-if="examine == 1">
				<img src="../../../../../../assets/channel/firstbusiness/success.png" alt="">
				审核中
			</div>
			<div class="TXsuccess" style="color: #00266D;" v-else-if="examine == 2">
				<img src="../../../../../../assets/channel/firstbusiness/successOK.png" alt="">
				审核中
			</div>
			<div :class="[ examine == 2 ? 'line1OK' : 'line1'  ]"></div>
			<div class="TXsuccess" style="color:#9CA5B8;" v-if="AuditStatus == 0">
				<img src="../../../../../../assets/channel/firstbusiness/successNO.png" alt="">
				审核成功
			</div>
			<div class="TXsuccess" style="color:#E71D43;" v-else-if="AuditStatus == 1">
				<img src="../../../../../../assets/channel/firstbusiness/error.png" alt="">
				已驳回
			</div>
			<div class="TXsuccess" v-else-if="AuditStatus == 2">
				<img src="../../../../../../assets/channel/firstbusiness/successOK.png" alt="">
				审核成功
			</div>
		</div>
		<div class="fromStyle">
			<FromComm :FromArr="FromArr"></FromComm>
			<CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="2" title="营业执照" @getFile="UploadBL"
				:BLPhotoURL="BLPhotoURL" :MaskTopFlag="MaskTopFlag"></CommonuploadEnclosure>
			<div class="remarks">
				支持上传jpg、jpeg、png格式的图片，最大支持5M
			</div>
		</div>
		<div class="TopLineBottom"></div>
		<TipsDialog ref="tipsdig" />
	</div>
</template>

<script>
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonuploadEnclosure from '../../../../../../components/common-upload-Enclosure.vue'
	import Btn from '../../../../../../components/common-btn'
	import FromArr from './FromData/FromData'
	import TipsDialog from '../../../components/TipsDialog.vue'
	import {
		LicenseGetBusinessLicense,
		LicenseAdd_BusinessLicense,
		LicenseUploadBusinessLicensePhoto
	} from '@/api/channel'
	import {
		CusType
	} from '@/api/home'

	export default {
		components: {
			FromComm,
			CommonuploadEnclosure,
			Btn,
			TipsDialog
		},
		props: {},
		data() {
			return {
				information: 1, //控制填写信息的状态[1:填写中 ， 2：填写成功]
				examine: 0, //控制审核中的状态[0: 审核未进行 ， 1：审核中 ， 2：审核中（进行下一步）]
				AuditStatus: 0, //控制是否审核成功的状态[0: 没有到这一步 ， 1: 已驳回 ， 2：审核通过]
				condition: 0, //控制右上角的状态变化
				FromArr: [], //表单数组
				RejectReason: null, //驳回原因
				BLPhotoURL: "", //上传照片成功返回的地址
				BLPhoto: "", //返回后端的图片地址
				BLPBtnFlag: 0, //控制底部按钮权限[0：提交审核 ，1：回填 ]
				StatusMenu: null,
				MaskTopFlag: false
			}
		},
		created() {},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.licenseGetBusinessLicense()
		},
		activated() {},
		updated() {},
		methods: {
			/*
			 *@Author: 史泽
			 *@Date: 2022-01-14 15:47:11
			 *@Description: this.$notify.error({
			      title: '错误',
			      message: '该用户没有权限'
			    });
			*/
			// 获取表单和回显（有数据回显没数据不回显）
			async licenseGetBusinessLicense() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await LicenseGetBusinessLicense({
					cusCode: "",
					cusType: "",
					status: null,
				})

				if (code == 0) {
					if (data != null) {
						this.FromArr.map((item, index) => {
							item.disabled = true
						})
						if (data.Status == 0) {
							this.information = 2 //填写完成
							this.examine = 1 //审核中
							this.condition = 1
						} else if (data.Status == -1) {
							this.information = 2 //填写完成
							this.examine = 2 //审核中
							this.AuditStatus = 1 //驳回
							this.condition = 3
						} else if (data.Status == 1) {
							this.information = 2 //填写完成
							this.examine = 2 //审核中
							this.AuditStatus = 2 //审核成功
							this.condition = 2
						}
						this.StatusMenu = data.Status
						this.RejectReason = data.RejectReason
						this.BLPhoto = data.BLPhoto
						this.BLPBtnFlag = 1
						this.BLPhotoURL = data.BLPhotoURL
						this.FromArr[0].modelvalue = data.BLCompanyName
						this.FromArr[1].modelvalue = data.BLCompanyType
						this.FromArr[2].modelvalue = data.BLUnifiedSocialCreditCode
						this.FromArr[3].modelvalue = data.BLLicenceCode
						this.FromArr[4].modelvalue = data.BLLegalRepresentative
						this.FromArr[5].modelvalue = data.BLBusinessScope
						this.FromArr[6].modelvalue = data.BLBusinessStartDate
						this.FromArr[7].modelvalue = data.BLBusinessEndDate
						this.FromArr[8].modelvalue = data.BLRegisteredCapital
						this.FromArr[9].modelvalue = data.BLEstablishmentDate
						this.FromArr[10].modelvalue = data.BLAddress
						if (data.BLPhoto) {
							this.MaskTopFlag = true
						}
						// this.StatusMenu

					} else if (data == null) {
						this.information = 1; //控制填写信息的状态[1:填写中 ， 2：填写成功]
						this.examine = 0; //控制审核中的状态[0: 审核未进行 ， 1：审核中 ， 2：审核中（进行下一步）]
						this.AuditStatus = 0; //控制是否审核成功的状态[0: 没有到这一步 ， 1: 已驳回 ， 2：审核通过]
						this.condition = 0 //控制右上角的状态变化
					}
				} else {
					this.$notify.warning({
						title: '警告',
						message: message
					})
				}
				loading.close();
			},
			// 提交营业执照信息
			async licenseAdd_BusinessLicense() {

				if (this.$refs.UploadEnclisureRef.BLPhotoURL == '') {
					this.BLPhoto = ''
				}
				let {
					code,
					data,
					message
				} = await LicenseAdd_BusinessLicense({
					BLCompanyName: this.FromArr[0].modelvalue,
					BLCompanyType: this.FromArr[1].modelvalue,
					BLUnifiedSocialCreditCode: this.FromArr[2].modelvalue,
					BLLicenceCode: this.FromArr[3].modelvalue,
					BLLegalRepresentative: this.FromArr[4].modelvalue,
					BLBusinessScope: this.FromArr[5].modelvalue,
					BLBusinessStartDate: this.FromArr[6].modelvalue,
					BLBusinessEndDate: this.FromArr[7].modelvalue,
					BLRegisteredCapital: this.FromArr[8].modelvalue,
					BLEstablishmentDate: this.FromArr[9].modelvalue,
					BLAddress: this.FromArr[10].modelvalue,
					BLPhoto: this.BLPhoto
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "提交成功"
					})
					this.information = 2 //填写完成
					this.examine = 1 //审核中
					this.condition = 1
					this.BLPBtnFlag = 1
					this.MaskTopFlag = true
					this.FromArr.map((item, index) => {
						item.disabled = true
					})
					this.$refs.tipsdig.getData();
				} else {
					this.$notify.warning({
						title: '警告',
						message: message
					})
				}
			},
			// 提交审核
			SubmitFreview() {
				this.licenseAdd_BusinessLicense()
			},
			//回填
			SubmitHT() {
				this.FromArr.map((item, index) => {
					item.disabled = false
				})
				this.BLPBtnFlag = 0
				this.MaskTopFlag = false
			},
			async licenseUploadBusinessLicensePhoto(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await LicenseUploadBusinessLicensePhoto(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.BLPhoto = res.data.BLPhoto
						this.BLPhotoURL = res.data.BLPhotoURL
						this.FromArr[0].modelvalue = res.data.BLCompanyName
						this.FromArr[1].modelvalue = res.data.BLCompanyType
						this.FromArr[2].modelvalue = res.data.BLUnifiedSocialCreditCode
						this.FromArr[3].modelvalue = res.data.BLLicenceCode
						this.FromArr[4].modelvalue = res.data.BLLegalRepresentative
						this.FromArr[5].modelvalue = res.data.BLBusinessScope
						this.FromArr[6].modelvalue = res.data.BLBusinessStartDate
						this.FromArr[7].modelvalue = res.data.BLBusinessEndDate
						this.FromArr[8].modelvalue = res.data.BLRegisteredCapital
						this.FromArr[9].modelvalue = res.data.BLEstablishmentDate
						this.FromArr[10].modelvalue = res.data.BLAddress
						loading.close();
						this.MaskTopFlag = false
					} else if (res.code == 101) {
						this.$notify.warning({
							title: '警告',
							message: res.message
						})
						loading.close();
					} else {
						this.$notify.error({
							title: '警告',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			UploadBL(file) {
				this.licenseUploadBusinessLicensePhoto(file)
			}
		},
		computed: {},
		watch: {

		},
	}
</script>
<style scoped lang='less'>
	.firstbusiness {
		width: 100%;
		position: relative;
		padding-bottom: 20px;

		.res {
			width: 100%;

			.reason {
				color: #16181a;
				font-size: 14px;
				font-weight: 500;
				margin: 22px;
			}

			.reasonText {
				width: 872px;
				// height: 32px;
				margin: 0 auto;
				background-color: #fef8f9;
				border: 1px solid #ebedf0;
				color: #e71d43;
				line-height: 32px;
				padding-left: 20px;
				margin-bottom: 30px;
				word-wrap: break-word;
			}
		}

		.TopTitle {
			font-size: 16px;
			color: #16181a;
			font-weight: 500;
			margin: 0px 24px 24px 24px;
		}

		.TopLine {
			height: 1px;
			width: 890px;
			background-color: #ebedf0;
			margin: 0 auto;
		}

		.TopLineBottom {
			height: 1px;
			width: 890px;
			background-color: #ebedf0;
			margin-left: 20px;
			margin-top: 100px;
			// margin: 20px auto;
		}

		.technological {
			width: 890px;
			margin: 0 auto;
			border-bottom: 1px solid #ebedf0;
			padding-top: 32px;
			padding-bottom: 32px;

			.TXsuccess {
				color: #00266d;
				font-size: 16px;
				font-weight: 500;
				margin-left: 55px;
				display: inline-block;

				img {
					width: 36px;
					height: 36px;
					vertical-align: middle;
				}
			}

			.line1 {
				width: 104px;
				height: 2px;
				border-bottom: 2px dotted #ced3d9;
				display: inline-block;
				margin-left: 70px;
				margin-bottom: 5px;
				transition: all 0.5s;
			}

			.line1OK {
				width: 104px;
				height: 2px;
				border-bottom: 2px dotted #00266d;
				display: inline-block;
				margin-left: 70px;
				margin-bottom: 5px;
				transition: all 0.5s;
			}
		}

		.TopTitleRight {
			color: #9ca5b8;
			font-size: 14px;
			float: right;
			position: relative;

			.spot {
				display: inline-block;
				width: 4px;
				height: 4px;
				background-color: #a1a9b3;
				position: relative;
				right: 5px;
				bottom: 4px;
			}

			.spotimg {
				display: inline-block;
				width: 12.5px;
				height: 10px;
				position: relative;
				right: 5px;
				bottom: 0px;
				background: url("../../../../../../assets/channel/menu/OK2.png") no-repeat 0px 0px;
				background-size: 100%;
			}

			.spotimgerror {
				display: inline-block;
				width: 12.5px;
				height: 10px;
				position: relative;
				right: 5px;
				bottom: 0px;
				background: url("../../../../../../assets/channel/menu/error1.png") no-repeat 0px 0px;
				background-size: 100%;
			}
		}

		.fromStyle {
			width: 100%;
			height: 550px;
			// border: 1px solid blue;

			.remarks {
				font-size: 14px;
				color: #9ca5b8;
				margin-left: 0px;
				margin-top: -40px;
			}
		}
	}

	.btnbtninformation {
		display: inline-block;
		// float: right;
		margin-right: 20px;
	}
</style>
